/* Relief Tech progressive enhancement: content remains visible without JS. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observed = new WeakSet();
  var choosers = new WeakSet();
  var animations = new Set();

  function reveal(scope) {
    if (!scope || !('IntersectionObserver' in window) || reduceMotion.matches) return;
    var items = scope.querySelectorAll('[data-rt-reveal]');
    var observer = new IntersectionObserver(function (entries, currentObserver) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || observed.has(entry.target)) return;
        if (reduceMotion.matches || !entry.target.animate) { currentObserver.unobserve(entry.target); return; }
        observed.add(entry.target);
        var animation = entry.target.animate(
          [
            { opacity: 0.7, transform: 'translateY(14px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          { duration: 520, delay: Math.min(entry.target.dataset.rtRevealDelay || 0, 180), easing: 'cubic-bezier(.22, 1, .36, 1)' }
        );
        animations.add(animation);
        animation.onfinish = function () { animations.delete(animation); };
        currentObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (item, index) {
      item.dataset.rtRevealDelay = index * 55;
      observer.observe(item);
    });
  }

  function initNeedChooser(scope) {
    var sections = scope.querySelectorAll ? scope.querySelectorAll('[data-rt-motion-section]') : [];
    sections.forEach(function (section) {
      if (choosers.has(section)) return;
      var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-rt-need-tab]'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('[data-rt-need-panel]'));
      if (!tabs.length || !panels.length) return;
      choosers.add(section);
      section.querySelector('[data-rt-tablist]').setAttribute('role', 'tablist');
      tabs.forEach(function (tab) { tab.setAttribute('role', 'tab'); });
      panels.forEach(function (panel) { panel.setAttribute('role', 'tabpanel'); });
      section.classList.add('rt-needs--js');
      function activate(index, moveFocus) {
        tabs.forEach(function (tab, tabIndex) {
          var active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach(function (panel, panelIndex) {
          var active = panelIndex === index;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
        if (moveFocus) tabs[index].focus();
      }
      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function (event) { event.preventDefault(); activate(index, false); });
        tab.addEventListener('keydown', function (event) {
          var next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(next, true);
        });
      });
      activate(Math.max(0, tabs.findIndex(function (tab) { return tab.getAttribute('aria-selected') === 'true'; })), false);
    });
  }

  function initCarousels(scope) {
    var tracks = scope.querySelectorAll ? scope.querySelectorAll('[data-rt-carousel]') : [];
    tracks.forEach(function (track) {
      if (choosers.has(track)) return;
      var root = track.closest('.rt-hero__featured');
      var prev = root && root.querySelector('[data-rt-carousel-prev]');
      var next = root && root.querySelector('[data-rt-carousel-next]');
      if (!prev || !next) return;
      choosers.add(track);
      function step() {
        var item = track.querySelector('.rt-hero__featured-item');
        return item ? item.getBoundingClientRect().width + 16 : 280;
      }
      function scrollByStep(direction) {
        track.scrollBy({ left: direction * step(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', function () { scrollByStep(-1); });
      next.addEventListener('click', function () { scrollByStep(1); });
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= max - 4;
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  var priceSelector = [
    '.rt-product__price',
    '.rt-product__compare-price',
    '.rt-card-one__price',
    '.rt-card-one__compare-price',
    '.rt-hero__featured-price',
    '.rt-hero__featured-compare',
    '.cart-item__final-price',
    '.cart-item__old-price',
    '.totals__subtotal-value > span'
  ].join(',');

  function formatPriceTextNode(text) {
    var fixed = text
      .replace(/([A-Za-zÀ-ÿ]{2,})(\d)/, '$1 $2')
      .replace(/(\d)([A-Za-zÀ-ÿ]{2,})/, '$1 $2');
    return fixed === text ? null : fixed;
  }

  function formatPrices(scope) {
    var nodes = (scope || document).querySelectorAll(priceSelector);
    nodes.forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var current;
      while ((current = walker.nextNode())) {
        if (!current.nodeValue.trim()) continue;
        var fixed = formatPriceTextNode(current.nodeValue);
        if (fixed) current.nodeValue = fixed;
      }
    });
  }

  function init(scope) { reveal(scope || document); initNeedChooser(scope || document); initCarousels(scope || document); formatPrices(scope || document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  reduceMotion.addEventListener && reduceMotion.addEventListener('change', function () {
    if (reduceMotion.matches) { animations.forEach(function (animation) { animation.cancel(); }); animations.clear(); }
  });
}());
